<template>
    <el-container style="height: 100%">
        <el-header>
            <van-nav-bar title="店销信息" left-text="返回" left-arrow @click-left="historyBackPath('intebotab')"/>
        </el-header>
        <el-main style="height: 100%">
            <el-form :inline="true" >
                <!--<el-form-item>
                    <el-button type="primary" @click="getInteboStaffAskByWechat" :loading="querybutton" size="mini">同步请假</el-button>
                </el-form-item>-->
                <el-form-item>
                    <el-radio-group v-model="type" size="mini" @change="typeChange">
                        <el-radio-button :label="1">本月</el-radio-button>
                        <el-radio-button :label="2">上月</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="batchInteboStaffAttend" :loading="querybutton" size="mini">保存</el-button>
                </el-form-item>
            </el-form>
            <el-table height="calc(100% - 4rem)" border :data="attendData" class="productTable" highlight-current-row>
                <el-table-column label="月份"  align="center" prop="mth">
                </el-table-column>
                <el-table-column label="姓名"  align="center" prop="staffname">
                </el-table-column>
                <el-table-column label="天数"  align="center" prop="days" width="100">
                    <template slot-scope="scope">
                        <el-input-number :ref="scope.column.property+'_'+scope.$index" @keyup.enter.native="tableEnter(scope)" :controls="false" size="mini" v-model="scope.row.days"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="操作"  align="center" width="100">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="saveInteboStaffAttend(scope.row)" :loading="querybutton" size="mini">保存</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            storeid:localStorage.getItem("storeid"),
            type:1,
            querybutton:false,
            fromdate:this.$moment().startOf('month').format('YYYY-MM-DD'),
            todate:this.$moment().endOf('month').format('YYYY-MM-DD'),
            attendData:[],
        }
    },
    created() {
        this.getInteboStaffAttendByMonth();

    },
    methods:{
        saveInteboStaffAttend(row){
            this.querybutton=true;
            let staffid=localStorage.getItem("staffid");
            let staffname=localStorage.getItem("staffname");
            row.createtor=staffid;
            row.createtorname=staffname;
            row.storeid=this.storeid;
            this.$postw("inteboStaff/saveInteboStaffAttend",row).then(res=>{
                this.querybutton=false;
                if(res.sucess){
                    this.$message({message: "保存成功", type: 'success'});
                }
            });
        },
        batchInteboStaffAttend(){
            this.querybutton=true;
            let staffid=localStorage.getItem("staffid");
            let staffname=localStorage.getItem("staffname");
            for(let val of this.attendData){
                val.createtor=staffid;
                val.createtorname=staffname;
                val.storeid=this.storeid;
            }
            this.$postw("inteboStaff/batchInteboStaffAttend?storeid="+this.storeid+"&month="+this.fromdate.substring(0,7),this.attendData).then(res=>{
                this.querybutton=false;
                if(res.sucess){
                    this.$message({message: "保存成功", type: 'success'});
                }
            });
        },
        setFocus(){
            this.$nextTick(function () {
                let inner = document.getElementsByClassName("el-input__inner");
                if (inner != null && inner.length > 0) {
                    for (let i = 0; i < inner.length - 1; i++) {
                        inner[i].addEventListener("click", function (e) {
                            this.select();
                        },true);
                    }
                }
            });
        },
        getInteboStaffAttendByMonth(){
            this.$post("inteboStaff/getInteboStaffAttendByMonth",{storeid:this.storeid,month:this.fromdate.substring(0,7)}).then(res=>{
                if(res.sucess){
                    this.attendData=res.object;
                    this.setFocus();
                }
            });
        },
        typeChange(){
            if(this.type==1){
                this.fromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                this.todate=this.$moment().endOf('month').format('YYYY-MM-DD');
            }
            else if(this.type==2){
                this.fromdate=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                this.todate=this.fromdate+"-"+this.$moment(this.fromdate, "YYYY-MM-DD").daysInMonth();
                this.fromdate=this.fromdate+"-01";
            }
            this.getInteboStaffAttendByMonth();
        },
        getInteboStaffAskByWechat(){
            this.querybutton=true;
            this.$post("inteboStaff/getInteboStaffAskByWechat",{fromdate:this.fromdate,todate:this.todate}).then(res=>{
                this.querybutton=false;
                if(res.sucess){
                    this.$message({message: "同步成功", type: 'success'});
                }
            });
        }
    }
}
</script>
<style lang="scss" rel="stylesheet/scss">
.productTable {
    &.el-table--enable-row-hover {
        /*.el-table__body {
            tr{
                &:hover{
                    &>td{
                        background-color:transparent;
                    }
                }
            }
        }*/
    }
    .el-table__row {
        td {
            padding: 0;
            .cell {
                padding: 0 !important;
                .el-input {
                    input {
                        font-size: .7rem;
                        text-align: initial;
                        background-color: transparent;
                        border: 1px solid transparent;
                        height: 1rem;
                        padding: 1rem .5rem;
                        border-radius: 0;
                        &:focus {
                            border-color: #409eff;
                            background-color: #fff;
                        }
                        &[disabled] {
                            background-color: #fbfbfb;
                        }
                    }
                }
                .el-select {
                    .el-input {
                        &.is-disabled {
                            .el-input__inner {
                                &:hover {
                                    border-color: transparent;
                                }
                            }
                        }
                    }
                }
                .el-date-editor {
                    &.el-input {
                        width: auto;
                    }
                    .el-input__prefix {
                        right: 0;
                        left: inherit;
                        .el-input__icon {
                            line-height: 1;
                            opacity: .2;
                        }
                    }
                    .el-input__suffix {
                        .el-icon-circle-close {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/page/intebo/intebostaff/intebostaffattend.vue